var map = {
	"./Verctor.svg": 7282,
	"./activate.svg": 7670,
	"./arrow-up-right.svg": 5715,
	"./arrow_down.svg": 9235,
	"./back-slide.svg": 1536,
	"./bell.svg": 3842,
	"./bell_active.svg": 3199,
	"./big_red_plus_circle.svg": 5963,
	"./black_magnifier.svg": 8523,
	"./blue_plus.svg": 7916,
	"./cart.svg": 2467,
	"./catalog.svg": 4366,
	"./catalog_cart.svg": 9979,
	"./catalog_pencil.svg": 8810,
	"./catalog_trash.svg": 1553,
	"./close.svg": 847,
	"./companies.svg": 842,
	"./contacts.svg": 4138,
	"./copy_invite.svg": 9098,
	"./copy_invites.svg": 885,
	"./cross_circle.svg": 202,
	"./devices-3.svg": 5302,
	"./devices.svg": 1262,
	"./devices2.svg": 336,
	"./dots.svg": 4857,
	"./edit.svg": 7281,
	"./email.svg": 3319,
	"./envelope.svg": 2017,
	"./eye-fill.svg": 7562,
	"./eye-slash-fill.svg": 2162,
	"./eye.svg": 352,
	"./file-text.svg": 4913,
	"./gray_magnifier.svg": 4793,
	"./home.svg": 6452,
	"./inn.svg": 8394,
	"./invites.svg": 4745,
	"./legal-home.svg": 9712,
	"./logout.svg": 9131,
	"./mail.svg": 3032,
	"./main.svg": 6106,
	"./managers.svg": 3898,
	"./minus.svg": 431,
	"./minus_circle.svg": 1154,
	"./next-slide.svg": 7638,
	"./next.svg": 3482,
	"./orders.svg": 7906,
	"./pencil.svg": 7330,
	"./pencil_2.svg": 7689,
	"./pencil_circle.svg": 4545,
	"./people.svg": 6788,
	"./phone.svg": 4647,
	"./plus.svg": 3969,
	"./plus_circle.svg": 8616,
	"./prev.svg": 6438,
	"./prices.svg": 9643,
	"./profile.svg": 5888,
	"./red_arrow.svg": 8064,
	"./red_arrow_down.svg": 5479,
	"./red_plus_circle.svg": 2628,
	"./red_trash.svg": 677,
	"./settings.svg": 6926,
	"./settings2.svg": 7824,
	"./sidebar-collapse.svg": 6393,
	"./skype.svg": 6561,
	"./spinner.svg": 5340,
	"./statistics.svg": 236,
	"./support.svg": 3318,
	"./telegram.svg": 64,
	"./telephone.svg": 8759,
	"./toast-cancel.svg": 8205,
	"./toast-checkmark.svg": 4226,
	"./trash-line.svg": 6496,
	"./trash-red.svg": 4235,
	"./trash.svg": 9865,
	"./whatsapp.svg": 6747,
	"shared/assets/sprites/Verctor.svg": 7282,
	"shared/assets/sprites/activate.svg": 7670,
	"shared/assets/sprites/arrow-up-right.svg": 5715,
	"shared/assets/sprites/arrow_down.svg": 9235,
	"shared/assets/sprites/back-slide.svg": 1536,
	"shared/assets/sprites/bell.svg": 3842,
	"shared/assets/sprites/bell_active.svg": 3199,
	"shared/assets/sprites/big_red_plus_circle.svg": 5963,
	"shared/assets/sprites/black_magnifier.svg": 8523,
	"shared/assets/sprites/blue_plus.svg": 7916,
	"shared/assets/sprites/cart.svg": 2467,
	"shared/assets/sprites/catalog.svg": 4366,
	"shared/assets/sprites/catalog_cart.svg": 9979,
	"shared/assets/sprites/catalog_pencil.svg": 8810,
	"shared/assets/sprites/catalog_trash.svg": 1553,
	"shared/assets/sprites/close.svg": 847,
	"shared/assets/sprites/companies.svg": 842,
	"shared/assets/sprites/contacts.svg": 4138,
	"shared/assets/sprites/copy_invite.svg": 9098,
	"shared/assets/sprites/copy_invites.svg": 885,
	"shared/assets/sprites/cross_circle.svg": 202,
	"shared/assets/sprites/devices-3.svg": 5302,
	"shared/assets/sprites/devices.svg": 1262,
	"shared/assets/sprites/devices2.svg": 336,
	"shared/assets/sprites/dots.svg": 4857,
	"shared/assets/sprites/edit.svg": 7281,
	"shared/assets/sprites/email.svg": 3319,
	"shared/assets/sprites/envelope.svg": 2017,
	"shared/assets/sprites/eye-fill.svg": 7562,
	"shared/assets/sprites/eye-slash-fill.svg": 2162,
	"shared/assets/sprites/eye.svg": 352,
	"shared/assets/sprites/file-text.svg": 4913,
	"shared/assets/sprites/gray_magnifier.svg": 4793,
	"shared/assets/sprites/home.svg": 6452,
	"shared/assets/sprites/inn.svg": 8394,
	"shared/assets/sprites/invites.svg": 4745,
	"shared/assets/sprites/legal-home.svg": 9712,
	"shared/assets/sprites/logout.svg": 9131,
	"shared/assets/sprites/mail.svg": 3032,
	"shared/assets/sprites/main.svg": 6106,
	"shared/assets/sprites/managers.svg": 3898,
	"shared/assets/sprites/minus.svg": 431,
	"shared/assets/sprites/minus_circle.svg": 1154,
	"shared/assets/sprites/next-slide.svg": 7638,
	"shared/assets/sprites/next.svg": 3482,
	"shared/assets/sprites/orders.svg": 7906,
	"shared/assets/sprites/pencil.svg": 7330,
	"shared/assets/sprites/pencil_2.svg": 7689,
	"shared/assets/sprites/pencil_circle.svg": 4545,
	"shared/assets/sprites/people.svg": 6788,
	"shared/assets/sprites/phone.svg": 4647,
	"shared/assets/sprites/plus.svg": 3969,
	"shared/assets/sprites/plus_circle.svg": 8616,
	"shared/assets/sprites/prev.svg": 6438,
	"shared/assets/sprites/prices.svg": 9643,
	"shared/assets/sprites/profile.svg": 5888,
	"shared/assets/sprites/red_arrow.svg": 8064,
	"shared/assets/sprites/red_arrow_down.svg": 5479,
	"shared/assets/sprites/red_plus_circle.svg": 2628,
	"shared/assets/sprites/red_trash.svg": 677,
	"shared/assets/sprites/settings.svg": 6926,
	"shared/assets/sprites/settings2.svg": 7824,
	"shared/assets/sprites/sidebar-collapse.svg": 6393,
	"shared/assets/sprites/skype.svg": 6561,
	"shared/assets/sprites/spinner.svg": 5340,
	"shared/assets/sprites/statistics.svg": 236,
	"shared/assets/sprites/support.svg": 3318,
	"shared/assets/sprites/telegram.svg": 64,
	"shared/assets/sprites/telephone.svg": 8759,
	"shared/assets/sprites/toast-cancel.svg": 8205,
	"shared/assets/sprites/toast-checkmark.svg": 4226,
	"shared/assets/sprites/trash-line.svg": 6496,
	"shared/assets/sprites/trash-red.svg": 4235,
	"shared/assets/sprites/trash.svg": 9865,
	"shared/assets/sprites/whatsapp.svg": 6747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8871;